/* template */
<template minapp="mpx" xlang="wxml"><div class="container"><mpx-view @tap.stop="goDetail" :class="({'schedule-item-nopay': !isPay})" class="schedule-item"><div class="status"><div class="status-icon" v-if="(title.showIcon)"></div><div class="status-icon-inner" v-if="(title.showIcon)"></div><div :class="({'status-highlight': title.highlight})" class="status-title">{{
          title.text
        }}</div><div class="pay" v-if="(!isPay)"><div class="pay-left"><div class="pay-amount">{{ payFee }}</div><div :style="[({color: '#FF6400'})] | transRpxStyle">元</div></div><div class="pay-right"><div class="pay-count" v-if="(timeLeft)">剩余{{ timeLeft }}</div><div class="pay-button">立即支付</div></div></div><div class="tips" v-else-if="(booked)">{{ tips }}</div><div class="scramble" v-else><div class="scramble-code">{{ alternativeTrainCodes }}</div><div class="scramble-gap"></div><div class="scramble-date">{{ alternativeStartDate }}</div></div></div><div :class="({'gap-nopay': !isPay})" class="gap"></div><div :style="[(trainInfoStyle)] | transRpxStyle" class="train-info"><div :style="[(unionJourney?'flex-shrink:0':'')] | transRpxStyle" class="train-info-icon" v-if="(booked)"></div><div :style="[(unionJourney?'margin-right:6px;flex-shrink:0':'')] | transRpxStyle" class="train-info-code" v-if="(booked)">{{ unionJourney ? transferCityName + '转' : code }}</div><div class="station-container">{{ fromInfo }}<es-icon name="arrow-switch-right" color="#666666" class="train-info-arrow"/><div class="train-info-end-container"><span class="train-info-end" v-if="(booked)"><span>{{ arriveTime }}</span><span class="train-info-daydiff">{{ dayDifference }}</span><span class="train-info-end-station">{{ toStation }}</span></span><span v-else>{{ toStation }}</span></div></div></div><div class="info-card" v-if="(booked && !unionJourney)"><div class="seat-info"><div class="seat-info-window">检票口<div :class="({'window': hasCheckEntrance})" class="seat-info-highlight" v-if="(window)">{{ window }}</div><div class="seat-info-highlight" v-else>详见车站大屏</div></div><div class="seat-info-gap"></div><div class="seat-info-code"><div class="seat-info-code-title">座次号<div class="seat-info-more" v-if="(showMoreBtn)">全部</div></div><div class="seat-info-highlight seat">{{ seatName }}</div></div></div></div><div class="transfer-info-box" v-if="(booked && unionJourney)"><div :style="[(isSingleOrder?'width:30vw':'margin-right:10px')] | transRpxStyle" class="info-card"><div class="seat-info"><div class="seat-info-window">1程{{ firstSegmentInfos || '' }}<div :class="({'window': hasCheckEntrance})" class="seat-info-highlight">{{
                firstSeatStatus
              }}</div></div></div></div><div :style="[(isSingleOrder?'width:30vw':'margin-left:10px')] | transRpxStyle" class="info-card"><div class="seat-info"><div class="seat-info-window">2程{{ secondSegmentInfos || '' }}<div :class="({'window': hasCheckEntrance})" class="seat-info-highlight">{{
                secondSeatStatus
              }}</div></div></div></div></div><div class="scramble-tips" v-if="(!booked)"><div class="scramble-tips-text"><hl-text color="#2F497D" hlColor="#338FFF" :text="(tips)"/></div><div class="scramble-tips-gap"></div><div>抢票成功率<span class="scramble-tips-rate">{{ successRate }}</span></div></div></mpx-view></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m79a99562"}'>
  .container
    display flex
    width 100%
  .schedule-item
    background #EAF3FF
    height fit-content
    border-radius 20px
    border 2px solid #FFFFFF
    padding 16px 16px 14px 16px
    font-family PingFang SC
    position relative
    font-size 12px
    width 100%
    // flex-shrink 0
    &::before
      content ''
      position absolute
      background url('https://dpubstatic.udache.com/static/dpubimg/273XDA_e4b022OkzrIO__.png')
      width 94px
      height 33px
      top 9.5px
      right 10.6px
      background-size cover
      background-repeat no-repeat
    &-nopay
      padding 12px 16px 14px 16px
    .status
      font-size 20px
      line-height 20px
      font-weight 500
      display flex
      align-items center
      position relative
      &-title
        min-width 60px
      &-icon
        width 24px
        height 24px
        margin-right 4px
        background url('https://dpubstatic.udache.com/static/dpubimg/sczyu52pU-WsvMf5Rwb_w.png')
        background-size cover
        background-repeat no-repeat
        margin-top -2px
        transfrom-origin center center
        transform rotate(45deg)
        animation-name test
        animation-duration 1s
        animation-iteration-count infinite
        @keyframes test
          0%
            transform rotate(0)
          100%
            transform rotate(360deg)
      &-icon-inner
        background url('https://dpubstatic.udache.com/static/dpubimg/kPqlmn8yE07krfP-OzG7x.png')
        width 6.775px
        height 7.975px
        background-size cover
        position absolute
        top 6px
        left 8.5px
      &-highlight
        color #338FFF
      .scramble
        display flex
        font-size 12px
        margin-left 10px
        color #666666
        align-items center
        &-code
          max-width 78.5px
          overflow hidden
          white-space nowrap
          text-overflow ellipsis
        &-gap
          height 12px
          background #2F497D
          margin 0 8px
          width 0.5px
          opacity 0.1
        &-date
          max-width 118px
          overflow hidden
          white-space nowrap
          text-overflow ellipsis
    .tips
      font-size 12px
      color #666666
      margin-left 8px
    .gap
      height 0.5px
      background #2F497D
      margin 14px 2px
      opacity 0.1
      &-nopay
        margin 12px 2px
    .train-info
      font-size 16px
      color #222222
      display flex
      align-items center
      &-icon
        background url('https://dpubstatic.udache.com/static/dpubimg/8y48h51kW3QsS8l543qNi.png')
        background-size cover
        width 15px
        height 15px
      &-code
        font-family PingFang HK
        font-weight 500
        margin-right 14px
        margin-left 6.75px
        display inline-block
      &-arrow
        margin 0 8px
      &-end-container
        flex 1
        overflow hidden
      &-end
        display flex
        &-station
          white-space nowrap
          text-overflow ellipsis
          overflow hidden
      &-daydiff
        font-size 10px
        margin-right 4px
    .station-container
      max-width 235px
      display flex
      align-items center
    .info-card
      margin-top 12px
      background #D2E6FF
      padding 14px 14px 12px 14px
      border-radius 10px
      font-size 12px
      color #2F497D
    .seat-info
      display flex
      &-window
        display flex
        flex-direction column
        width 104px
      &-gap
        background #2F497D
        width 0.5px
        margin-right 14px
        padding -1px 0
        opacity 0.1
      &-code
        display flex
        flex-direction column
        &-title
          display flex
          justify-content space-between
          align-items center
      &-more
        position relative
        margin-right 10px
        &::after
          content ''
          position absolute
          background url('https://dpubstatic.udache.com/static/dpubimg/1uNQRIzZfGIb_5I8_oi-i.png')
          background-size cover
          width 10px
          height 10px
          top 3px
          right -10px
      &-highlight
        color #222222
        font-size 15px
        font-weight 500
        margin-top 4px
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
      .window
        max-width 96px
        font-size 18px
      .seat
        max-width 160px
        margin-top 4px
    .transfer-info-box
      display flex
      justify-content space-around
    .scramble-tips
      display flex
      flex-direction column
      margin-top 11px
      background #D2E6FF
      padding 8px 14px 8px 14px
      border-radius 10px
      font-size 12px
      color #2F497D
      &-text
        max-width 275px
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
      &-highlight
        color #338FFF
        margin 0 2px
      &-gap
        height 0.5px
        // width 299px
        background #2F497D
        margin 8px -2px
        opacity 0.1
      &-rate
        color #222222
        font-weight 500
        font-size 16px
        margin-left 6px
    .pay
      color #666666
      display flex
      justify-content space-between
      font-size 12px
      align-items center
      width 100%
      &-left
        display flex
        align-items baseline
        margin-top 4px
      &-amount
        color #FF6400
        font-size 22px
        margin 0 1px 0 4px
        font-weight 500
      &-right
        display flex
        align-items center
      &-button
        display flex
        background #FF6400
        color #FFFFFF
        font-weight 500
        border-radius 50px
        margin-left 10px
        width 70px
        height 28px
        align-items center
        justify-content center
        z-index 1
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m79a99562"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./schedule-item.mpx.js?isComponent&outputPath=components%2Fschedule-item79a99562%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./schedule-item.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fschedule-item79a99562%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m79a99562"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/schedule-item79a99562/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'hl-text':getComponent(require("../../../../components/hl-text/index.mpx?isComponent&outputPath=components%2Findex10de904a%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
